module.exports = __webpack_public_path__ + "static/media/PDM_logo.8477eb07.svg";